import type { JSX } from "react";
import { PROJECTS } from "@/ui/MonitorContent/Projects/data/projects";
import { useSceneStore } from "@/state/useSceneStore";

export const ProjectsIndex = (): JSX.Element => {
  const setRoute = useSceneStore((s) => s.setActiveMonitorRoute);
  return (
    <ul
      className="grid gap-3"
      style={{
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
      }}
    >
      {PROJECTS.map((p) => (
        <li key={p.slug}>
          <button
            type="button"
            onClick={() => setRoute(`#/projects/${p.slug}`)}
            className="block w-full border border-rule text-left transition-colors hover:border-phosphor"
          >
            <img
              src={p.thumb}
              alt={p.title}
              className="aspect-video w-full object-cover"
              loading="lazy"
            />
            <div className="p-3">
              <div className="font-display text-lg">{p.title}</div>
              <div className="mt-1 flex flex-wrap gap-1 font-mono text-[10px] uppercase text-ink2">
                {p.tags.slice(0, 3).map((t) => (
                  <span key={t} className="border border-rule px-1.5">
                    {t}
                  </span>
                ))}
                <span className="ml-auto">{p.year}</span>
              </div>
            </div>
          </button>
        </li>
      ))}
    </ul>
  );
};
